const buttonBase = `
whitespace-nowrap inline-flex items-center justify-center px-2 py-1 border
border-transparent rounded-md shadow-sm text-base font-medium
disabled:cursor-not-allowed hover:shadow
`;

export const link = `text-blue-600 hover:text-blue-500`;

export const button = `${buttonBase} text-gray-700 border-gray-100 disabled:text-gray-300`;
export const buttonActive = 'shadow-inner bg-gray-50';

const buttonLargeBase = `${buttonBase} px-4 py-2`;
export const buttonSecondary = `${buttonLargeBase} text-gray-600 bg-gray-50 hover:bg-gray-100 disabled:bg-gray-200 disabled:text-gray-300`;
export const buttonPrimary = `
${buttonLargeBase} text-white bg-blue-500 hover:bg-blue-600 disabled:bg-gray-200 disabled:text-gray-300 disabled:cursor-not-allowed
`;
export const buttonDanger = `${buttonLargeBase} text-white bg-red-600 hover:bg-red-600 disabled:bg-gray-200 disabled:text-gray-300 disabled:cursor-not-allowed
`;

export const formInputBase = 'block border px-3 py-2 border-gray-300 rounded';
export const formInput = `${formInputBase} w-full`;
export const formInputLabel = 'block text-sm leading-6 font-medium';
export const formSelect =
  'mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm';

export const navLinkBase = 'px-3 py-2 rounded-md text-sm font-medium';
export const navLinkDeselected = `${navLinkBase} text-gray-600 hover:bg-gray-400 hover:text-white`;
export const navLinkSelected = `${navLinkBase} bg-gray-900 text-white`;

export const ringBorder = 'rounded-md ring-1 ring-black ring-opacity-5 focus:outline-none bg-white';

export const floatingDropdownNoPad = `absolute z-10 rounded-md shadow-lg ${ringBorder}`;
export const floatingDropdown = `${floatingDropdownNoPad} py-1`;
export const floatingDropdownItem = 'block px-4 py-2 text-sm text-gray-700';

export const showOnGroupHover =
  'invisible group-hover:visible transition-opacity opacity-0 group-hover:opacity-100';

export const section = 'my-6 p-6 rounded-xl border-2 border-gray-100';
export const sectionHeader = 'flex items-center justify-between flex-wrap gap-6';
export const sectionTitle = 'text-xl font-bold';
export const withModelAnnotation = 'flex items-center justify-evenly gap-6';
export const sectionBody = 'pt-6 space-y-12';

/** Transparent right border gives illustion of padding right of arrow. */
export const select = `h-8 px-2 py-1 rounded-md ${ringBorder} border-r-8 border-transparent`;
